import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=35b2fb06&"
import script from "./RequestList.vue?vue&type=script&lang=js&"
export * from "./RequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b2fb06')) {
      api.createRecord('35b2fb06', component.options)
    } else {
      api.reload('35b2fb06', component.options)
    }
    module.hot.accept("./RequestList.vue?vue&type=template&id=35b2fb06&", function () {
      api.rerender('35b2fb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/services/requests/RequestList.vue"
export default component.exports